module.exports = __webpack_public_path__ + "img/15.bd0219d5.jpg";